<template>
  <div class="mask" v-show="show">
    <div class="wrapper">
      <div class="headline">
        <p class="title">
          选择地址
        </p>
        <img src="../assets/img/interview/close.svg" alt="close" class="close" @click="close()">
      </div>
      <div class="container">
        <div class="list">
          <div class="inputer">
            <input class="enter" type="text" placeholder="请输入关键词" v-model="keyword" @keyup.enter="search()">
            <img src="../assets/img/interview/search.svg" alt="search" class="search" @click="search()">
          </div>
          <div class="content" id="result">
            <ul>
              <li @click="selectAddress(r)" :class="{active: r.uid === selected.uid}" v-for="(r, i) in results" style="margin: 2px 0px; padding: 0px 5px 5px 0px; cursor: pointer; overflow: hidden; line-height: 17px;">
                <span :style="{background:`url(http://api.map.baidu.com/images/markers.png) -23px -${i*25}px no-repeat`, width:'19px', height:'25px', cursor:'pointer', float:'left',zoom: '1', overflow: 'hidden',margin:'2px 0 0 5px', display:'inline'}"></span>
                <div style="zoom:1;overflow:hidden;padding:0 5px;">
                  <div style="line-height:20px;font-size:12px;">
                    <span style="color:#00c;">{{r.title}}</span>
                  </div>
                  <div style="padding:2px 0;line-height:18px;*zoom:1;overflow:hidden;">
                    <b style="float:left;font-weight:bold;*zoom:1;overflow:hidden;padding-right:5px;*margin-right:-3px;">地址:</b>
                    <span style="color:#666;display:block;zoom:1;overflow:hidden;">{{r.address}}</span>
                  </div>
                  <div style="padding:2px 0;line-height:18px;*zoom:1;overflow:hidden;">
                    <b style="float:left;font-weight:bold;*zoom:1;overflow:hidden;padding-right:5px;*margin-right:-3px;">电话:</b>
                    <span style="color:#666;">{{r.phoneNumber}}</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="map" id="map"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as config from '@common/config'

export default {
  name: 'location',
  data() {
    return {
      map: null,
      show: false,
      geocoder: null,
      keyword: '',
      results: [],
      selected: {}
    }
  },
  methods: {
    selectPoint(e) {
      // this.geocoder.getLocation(e.point, (res) => {
      //   this.$emit('getLocation', res.address)
      //   this.close()
      // })
      this.$emit('getLocation', e)
      this.close()
    },
    getSearchResults(r) {
      console.log(1111, r)
      if (r) {
        this.results = r.Br || r.Ar || r.Ir || r.Hr || r.Kr || r.Xr || r.Yr || r.Zr || r.as || r.Rr // SB baidu, 天天改字段, 10.09 SB baidu 又改字段了，20250808改了字段Rr
        console.log('tt', this.results)
        this.addResultsToMap()
      } else {
        this.results = []
      }
    },
    addResultsToMap(rslt) {
      // 将搜索结果放置地图之上
      const points = []
      this.results.forEach((i, d) => {
        const icon = new BMap.Icon("http://api.map.baidu.com/images/markers.png", new BMap.Size(19,25),{offset: new BMap.Size(0, 0), imageOffset: new BMap.Size(0, -d*25) })
        const marker = new BMap.Marker(i.point, {icon: icon})
        this.map.addOverlay(marker)
        marker.addEventListener("click", (event) => {
  				var point = event.target.point;
          console.log(123, point)
          this.selectAddress(i)
  			})

        points.push(i.point)
      })
      this.map.setViewport(points)
    },
    load() {
      const mp = new BMap.Map('map')
      this.map = mp
      this.geocoder= new BMap.Geocoder()
      this.local = new BMap.LocalSearch(mp, {
    		onSearchComplete: this.getSearchResults
    	})
      mp.centerAndZoom(new BMap.Point(121.491, 31.233), 16)
      mp.enableScrollWheelZoom(true)

      const top_left_control = new BMap.ScaleControl({anchor: BMAP_ANCHOR_TOP_LEFT})
			const top_left_navigation = new BMap.NavigationControl()
			const overView = new BMap.OverviewMapControl()
			const overViewOpen = new BMap.OverviewMapControl({isOpen:false, anchor: BMAP_ANCHOR_BOTTOM_RIGHT})

			this.map.addControl(new BMap.MapTypeControl());
			this.map.addControl(top_left_control);
			this.map.addControl(top_left_navigation);
		  this.map.addControl(overView);
			this.map.addControl(overViewOpen);
      window.selectPoint = this.selectPoint
    },
    init() {
      const callback = '_bdcallback'
      const apiUrl = config.bdmap + callback
      window[callback] = this.load

      const script = document.createElement('script')
      script.src = apiUrl
      document.body.appendChild(script)
    },
    search() {
      // 搜索列表
      const keyword = this.keyword

      this.local.search(keyword)
    },
    selectAddress(a) {
      // 选中列表地址
      this.selected = a
      const infowindow = this.buildInfoWindow(a.title, a.address, a.point)
      this.map.openInfoWindow(infowindow, a.point)
    },
    buildInfoWindow(title, address, point) {
      // 生成自定义弹窗
      if(!address){
        address = ''
      }
      const info = `<div>坐标：${point.lng} ${point.lat}</div><div>地址：${address}</div>`
      const a = `<div><a href="javascript:void(0);" style="float: right; color: rgb(0, 0, 204)" onclick="selectPoint('${address}')" title="更新地址">更新地址</a></div>`
      const html = info + a
      const infoWindow = new BMap.InfoWindow(html, {
  			title  : title,
  			panel  : "panel",
  			enableAutoPan : true,
  			enableMessage:false
  		})

      return infoWindow
    },
    open() {
      this.show = true
    },
    close() {
      this.show = false
    }
  },
  created() {
    this.init()
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/global.less';

.mask {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  position: fixed;
  z-index: 11111;
  background-color: rgba(0,0,0,0.70);
  display: flex;
  align-items: center;
  justify-content: center;
  .wrapper {
    .boxOuter;
    width: 880px;
    height: 560px;
    .headline {
      height: 70px;
      padding: 0 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title {
        font-size: 24px;
        color: @dark;
        font-weight: bold;
      }
      .close {
        cursor: pointer;
      }
    }
    .container {
      height: 490px;
      padding: 0 30px 40px;
      display: flex;
      justify-content: space-between;
      .list {
        width: 300px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .inputer {
          height: 36px;
          background-color: rgba(185,195,195,0.20);
          border-radius: 4px;
          display: flex;
          align-items: center;
          padding: 0 10px 0 20px;
          justify-content: space-between;
          .enter {
            flex: 1;
            color: @dark;
            font-size: 16px;
            background-color: transparent;
            &::placeholder {
              color: @dateColor;
            }
          }
          .search {
            margin-left: 10px;
            cursor: pointer;
          }
        }
        .content {
          flex: 1;
          margin-top: 20px;
          overflow-y: auto;
          &::-webkit-scrollbar {
              width: 6px;
              height: auto;
          }
          &::-webkit-scrollbar-thumb {
              background: #ddd;
              border-radius: 2px;
          }
          .active {
            background-color: #f2f2ea;
          }
        }
      }
      .map {
        width: 500px;
        height: 100%
      }
    }
  }
}
</style>
